export function stepsSlider() {
    const $sliderWrapper = $(".steps-block");
    const $slider = $(".steps-slider");
    const $sliderTabs = $(".slider-tabs");
    const $sliderTab = $(".tags-item");
    const $window = $(window);
    $slider.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        infinite: true,
        asNavFor: $sliderTabs,
        autoplay: true,
        autoplaySpeed: 6100,
        pauseOnHover: false,
        prevArrow: "<button class=\"slide-arrow slick-prev\"><svg width=\"13\" height=\"10\" viewBox=\"0 0 13 10\">\n" +
            "<path d=\"M5.76256 9.95006L6.38128 9.33134L2.48645 5.43651L12.751 5.43651L12.751 4.56412L2.48645 4.56412L6.38128 0.669287L5.76256 0.0505685L0.812815 5.00032L5.76256 9.95006Z\" fill=\"#111111\"/>\n" +
            "</svg></button>",
        nextArrow: "<button class=\"slide-arrow slick-next\"><svg width=\"13\" height=\"10\" viewBox=\"0 0 13 10\">\n" +
            "<path d=\"M7.23744 9.95006L6.61872 9.33134L10.5136 5.43651L0.249013 5.43651L0.249013 4.56412L10.5136 4.56412L6.61872 0.669287L7.23744 0.0505685L12.1872 5.00032L7.23744 9.95006Z\" fill=\"#111111\"/>\n" +
            "</svg></button>",
        mobileFirst: true,
        responsive: [
            {
                breakpoint: 300,
                settings: {
                    arrows: true
                }
            },
            {
                breakpoint: 1023,
                settings: {
                    arrows: false
                }
            }, {
                breakpoint: 1200,
                settings: {
                    adaptiveHeight: false
                }
            }
        ]
    });
    $sliderTabs.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        asNavFor: $slider,
        arrows: false,
        dots: false,
        fade: true,
        focusOnSelect: true,
        mobileFirst: true,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 6100,
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1,
                    fade: false
                }
            }
        ]
    });
    $window.on("resize", function () {
        $sliderWrapper.hover(function () {
            $sliderTabs.find(".slick-current .tags-item").addClass("paused");
        }, function () {
            $sliderTabs.find($sliderTab).removeClass("paused");
        });
    });
    
    if ($window.width() >= 1200) {
        $sliderTab.hover(function () {
            $sliderTabs.find(".slick-current .tags-item").addClass("paused");
            $slider.slick("slickPause");
        }, function () {
            $sliderTabs.find($sliderTab).removeClass("paused");
            $slider.slick("slickPlay");
        });
    }
    $sliderTab.on("click", function () {
        $sliderTab.removeClass("paused");
    });
    $slider.on("beforeChange", function (){
        let $video = $slider.find("video");
        if($video.length){
            $video.get(0).pause();
        }
    });
    $slider.on("afterChange", function (event, slick, currentSlide){
        let $video = $(slick.$slides[currentSlide]).find("video");
        if($video.length){
            $video.get(0).play();
        }
    });
}



// WEBPACK FOOTER //
// ./assets/js/modules/stepsSlider.js